/* eslint-disable eqeqeq */
import { promisify } from "./_utils/promisify";
import { styleIn } from "./_utils/styleOptions";
export function normalize(api, containerName) {
  return function (args) {
    return promisify(api)(styleIn(args, containerName));
  };
}